import { NgModule } from '@angular/core';
import { ApiInterceptorProvider } from './interceptors/api.interceptor';
import { AuthService } from '@pxl/core/services/auth.service';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { LayoutComponent } from './components/layout/layout.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { ApiService } from './services/api.service';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthStore } from './store/auth.store';
import { MatDividerModule } from '@angular/material/divider';
import { InviteUserDialogComponent } from './components/invite-user-dialog/invite-user-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { AllowOnlyAnonymousGuard } from './guards/allow-only-anonymous.guard';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
  declarations: [
    HeaderComponent,
    LayoutComponent,
    UserMenuComponent,
    InviteUserDialogComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    MatDividerModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatSidenavModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAuth(() => getAuth()),
    AuthService,
    ApiService,
    AuthenticatedGuard,
    AllowOnlyAnonymousGuard,
    AuthStore,
    ApiInterceptorProvider
  ],
  exports: [LayoutComponent, ConfirmationDialogComponent]
})
export class CoreModule {}
